import * as css from './Groups.css';
import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import {getEventGroups, getEventTickets} from '../../../redux/tickets/ticketsActions';
import Group from './group/Group';
import AnotherOne from '../../../component/anotherOne/AnotherOne';
import {useTranslation} from 'react-i18next';
import PopUp from './popUp/PopUp';
import store from '../../../store';
import {useNavigate, useLocation} from 'react-router-dom';
import {add} from '../../../assets/symbols/symbols/Symbols.css';

function Groups() {
    const {t} = useTranslation('ticket');
    const tickets = useSelector(s => s.tickets);
    const groupsInfo = tickets.groups;
    const [{popup, item}, setPopUp] = useState({popup: false, item: false});
    const navigate = useNavigate();
    const location = useLocation();
    const groups = useSelector(s => s.tickets.groups);

    const operations = [{
        key: 0, text: t('createGroup'), onClick: () => {
            handlePopUp(true, false);
        }, icon: add
    }];

    const handlePopUp = (show, item) => {
        setPopUp({popup: show, item: item});
    };

    const openGroup = (group) => {
        navigate(`${location.pathname}/${group}`);
    };

    useEffect(() => {
        if(!store.getState().tickets.groups.length)
            getEventGroups().then();
        if(!store.getState().tickets.tickets.length)
            getEventTickets().then();
    }, []);

    const updateGroupXHR = tickets.updateGroupFullXHR;
    const addGroupXHR = tickets.addGroupFullXHR;
    
    useEffect(() => {
        if(updateGroupXHR === 'SUCCESS' || addGroupXHR === 'SUCCESS')
            setPopUp({popup: false, item: false});
    }, [updateGroupXHR, addGroupXHR]);

    useEffect(() => {
        if(addGroupXHR === 'SUCCESS') 
            openGroup(groups[groups.length - 1].gid);
    }, [groups]);

    return (
        <>
            <PageWrapper image={'ticketsGroups'} operations={{buttons: operations}} className={'ticketsGroups'} mobileActions={operations}>
                {
                    <>
                        <css.groupsArea data-cy="groups">
                            {groupsInfo?.map((item, index) => (
                                <Group key={index} item={item} color={item.color} openPopUp={(item) => handlePopUp(true, item)} index={index} openGroup={openGroup} />
                            ))}
                            <AnotherOne title={t('addGroup')} onClick={() => handlePopUp(true, false)}  dataCyName ="groups" />
                            {popup && <PopUp closePop={() => handlePopUp(false, false)} item={item}/>}
                        </css.groupsArea>
                    </>}
            </PageWrapper>
        </>
    );
}

export default Groups;
